import Image from "next/image";
import React from "react";

export default function FundingAcknowledgment() {
    return (
        <div
            style={{
                backgroundColor: "#ffffff",
                padding: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "16px",
                borderRadius: "4px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "20px",
                    flexWrap: "wrap",
                }}
            >
                <a
                    href="https://next-generation-eu.europa.eu/index_en"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Image
                        src="/NextGenerationEU.jpg"
                        alt="Next Generation EU"
                        width={120}
                        height={80}
                        style={{
                            objectFit: "contain",
                            maxWidth: "100%",
                            height: "auto",
                        }}
                    />
                </a>
                <a
                    href="https://hamagbicro.hr/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Image
                        src="/HamagBicro.png"
                        alt="HAMAG-BICRO"
                        width={120}
                        height={80}
                        style={{
                            objectFit: "contain",
                            maxWidth: "100%",
                            height: "auto",
                        }}
                    />
                </a>
            </div>
        </div>
    );
}
